import {PointOfContactProps} from "@/interfaces/point-of-contact_types.ts";
import { z } from "zod";
import { PointOfContactFormSchema } from "./DefaultSchema";

export function ImportFormProps({formProps} : {formProps?: PointOfContactProps}) {
    if (!formProps) return {}
    
    return {
        uuid: formProps.uuid ?? "",
        name: formProps.name ?? "",
        email: formProps.email ?? "",
        phone_number: formProps.phone_number ?? "",
        client_name: formProps.assigned_client ? {
            value: formProps.assigned_client.name,
            label: formProps.assigned_client.name
        } : undefined
    } as z.infer<typeof PointOfContactFormSchema>
}